// -- [Content resolution: getCurrentCopy, resetPreferences]

import type { ContentConfig, RoleKey } from '@/types/content'
import { clearStoredPreferences } from './storage'

export interface CurrentCopy {
  heroHeadline: string
  heroSubheadline: string
  heroBullets: string[]
  heroBackgroundImage?: string
  emphasisedSections: string[]
}

export function getCurrentCopy(
  config: ContentConfig,
  roleKey: RoleKey,
  topicKey: string
): CurrentCopy {
  const role = config.roles[roleKey]
  if (!role) {
    const firstRole = Object.keys(config.roles)[0] as RoleKey
    const firstTopic = config.roles[firstRole]?.topics[0]
    return {
      heroHeadline: firstTopic?.heroHeadline ?? '',
      heroSubheadline: firstTopic?.heroSubheadline ?? '',
      heroBullets: firstTopic?.heroBullets ?? [],
      heroBackgroundImage: firstTopic?.heroBackgroundImage,
      emphasisedSections: firstTopic?.emphasisedSections ?? [],
    }
  }

  const topic = role.topics.find((t) => t.key === topicKey) ?? role.topics[0]
  if (!topic) {
    return {
      heroHeadline: '',
      heroSubheadline: '',
      heroBullets: [],
      heroBackgroundImage: undefined,
      emphasisedSections: [],
    }
  }

  return {
    heroHeadline: topic.heroHeadline,
    heroSubheadline: topic.heroSubheadline,
    heroBullets: topic.heroBullets,
    heroBackgroundImage: topic.heroBackgroundImage,
    emphasisedSections: topic.emphasisedSections,
  }
}

export function resetPreferences(): void {
  clearStoredPreferences()
}
